import { Sparkles, UserPlus, Lock } from "lucide-react";
import { Button } from "@ui";
import { PALETTE, BG_PALETTE } from "../lib/theme";

// Rendered in place of the form when the anonymous quota for this
// browser session has been consumed (one analysis per session). Mirrors
// the visual language of `CtaCard` so the upsell feels native.
export function QuotaExhausted() {
  return (
    <section className="w-full px-4 py-6 sm:mx-auto sm:max-w-xl">
      <div
        className="overflow-hidden rounded-2xl"
        style={{ boxShadow: "0 2px 16px rgba(127,119,221,0.13)" }}
      >
        <header
          className="px-4 pt-6 pb-5 text-center"
          style={{
            background: BG_PALETTE[5],
            borderBottom: `1.5px solid ${PALETTE[5]}22`,
          }}
        >
          <div className="mb-3 flex items-center justify-center gap-2">
            <div
              className="flex h-9 w-9 items-center justify-center rounded-lg bg-white"
              style={{ boxShadow: `0 1px 4px ${PALETTE[5]}44` }}
            >
              <Lock size={16} color={PALETTE[5]} strokeWidth={2} />
            </div>
            <span
              className="text-[11px] font-bold uppercase tracking-widest"
              style={{ color: PALETTE[5] }}
            >
              Analyse gratuite déjà utilisée
            </span>
          </div>
          <h2 className="text-lg font-bold leading-snug text-slate-900">
            Pour aller plus loin, créez votre compte inSiti
          </h2>
          <p className="mt-2 text-sm text-slate-600 leading-relaxed">
            Vous avez utilisé votre analyse gratuite pour cette session.
            Décrivez-nous votre projet pour obtenir 5 analyses supplémentaires,
            100% personnalisées.
          </p>
        </header>

        <div className="bg-white p-4 sm:p-5">
          <Button
            to="/inscription/candidat"
            target="_blank"
            size="lg"
            icon={UserPlus}
            className="w-full justify-center"
          >
            Décrire mon projet sur inSiti
          </Button>

          <div className="my-4 flex items-center gap-2 text-xs text-slate-400">
            <span className="h-px flex-1 bg-slate-200" />
            <span>OU</span>
            <span className="h-px flex-1 bg-slate-200" />
          </div>

          <Button
            to="/authentification"
            target="_blank"
            size="md"
            variant="white"
            icon={Sparkles}
            className="w-full justify-center"
          >
            Me connecter
          </Button>

          <p className="mt-3 text-center text-xs text-slate-400">
            ✓ Gratuit · Résultat immédiat · 100% sur-mesure
          </p>
        </div>
      </div>
    </section>
  );
}
